import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuthDispatch, useAuthState, fetchUserRoles } from "../Context";
import { useAuthenticator } from "@aws-amplify/ui-react";
import PropTypes from 'prop-types';


const RoleBasedAccess = ({ allowedRoles = [], children }) => {
  const dispatch = useAuthDispatch();
  const { userGroup } = useAuthState();
  const { route } = useAuthenticator((context) => [context.route]); // Access `route` from useAuthenticator
  const [isLoading, setIsLoading] = useState(true);

  // console.log("user group:", userGroup);
  // console.log("route from hook is:", route);
  // console.log("allowed roles:", allowedRoles);

  useEffect(() => {
    if (route === "signOut") {
      setIsLoading(false); // Skip fetching roles if the user is signing out
      return;
    }
    const loadUserRoles = async () => {
      console.log("Fetching user roles...");
      try {
        await fetchUserRoles(dispatch); // Fetch roles and update global state
      } catch (error) {
        console.error("Error loading user roles:", error);
      } finally {
        setIsLoading(false);
      }
    };
    loadUserRoles();
  }, [dispatch, route]);

  if (isLoading) {
    return <div>Chekcing User Role......</div>; // Show a loading indicator while fetching roles
  }

  
  if (
    allowedRoles.length > 0 &&
    (!userGroup || !allowedRoles.some((role) => userGroup.includes(role)))
  ) {
    return <Navigate to="/" />;
  }

  // if allowedRoles is empty, allow access for all roles
  return children;
};

RoleBasedAccess.propTypes = {
  allowedRoles: PropTypes.arrayOf(PropTypes.string).isRequired, 
  children: PropTypes.node.isRequired,
};

export default RoleBasedAccess;
